import React from "react";
import { Table, Empty, Spin } from "antd";
import { Link } from "react-router-dom";
import { useGetEbaySyncedProductsQuery } from "@/api/ebayApi";
import {
  Section,
  SectionTitle,
  TableWrap,
} from "./styles";

function formatDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "—" : date.toLocaleDateString();
}

export const EbaySyncedProducts = () => {
  const { data: products = [], isLoading, isFetching } =
    useGetEbaySyncedProductsQuery();

  const columns = [
    {
      title: "Product",
      dataIndex: "title",
      key: "title",
      render: (title, record) =>
        record.localProductId ? (
          <Link to={`/product/${record.localProductId}`}>{title}</Link>
        ) : (
          title
        ),
    },
    {
      title: "SKU",
      dataIndex: "sku",
      key: "sku",
      render: (sku) => sku || "—",
    },
    {
      title: "eBay Item ID",
      dataIndex: "ebayItemId",
      key: "ebayItemId",
      render: (ebayItemId) => ebayItemId || "—",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => status || "—",
    },
    {
      title: "Synced",
      dataIndex: "syncedAt",
      key: "syncedAt",
      render: (syncedAt) => formatDate(syncedAt),
    },
  ];

  return (
    <Section>
      <SectionTitle>eBay Synced Products</SectionTitle>
      {isLoading ? (
        <div style={{ display: "flex", justifyContent: "center", padding: 32 }}>
          <Spin />
        </div>
      ) : products.length === 0 ? (
        <Empty description="No products synced to eBay yet." />
      ) : (
        <TableWrap>
          <Table
            rowKey="id"
            columns={columns}
            dataSource={products}
            loading={isFetching && !isLoading}
            pagination={{ pageSize: 10, showSizeChanger: false }}
            scroll={{ x: 640 }}
            size="middle"
          />
        </TableWrap>
      )}
    </Section>
  );
};
